import * as React from 'react';

import {Button} from 'shells/button/button';
import {Dialog} from 'shells/dialog/dialog';

export type Props = {
    selectedCount: number;
    displayName: string;
    handleDelete: () => void;
};

export function DeleteButton(props: Props) {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false);

    const deleteRef = React.useRef(null);

    return (
        <>
            <Button
                getButtonRef={deleteRef}
                variant='danger'
                size='big'
                disabled={props.selectedCount === 0}
                onClick={() => setIsDialogOpen(true)}
            >
                Delete
            </Button>
            {isDialogOpen && (
                <Dialog
                    anchor={deleteRef.current}
                    location='right'
                    isWarning={true}
                    question={`Are you certain you want to permanently delete ${props.selectedCount} ${props.displayName}?`}
                    onPrimary={props.handleDelete}
                    onSecondary={() => setIsDialogOpen(false)}
                />
            )}
        </>
    );
}
